<template functional>
  <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M17.4727 4.42969H15.3633C15.072 4.42969 14.8359 4.66576 14.8359 4.95703V15.5039C14.8359 15.7952 15.072 16.0312 15.3633 16.0312H17.4727C17.7639 16.0312 18 15.7952 18 15.5039V4.95703C18 4.66576 17.7639 4.42969 17.4727 4.42969Z"
        fill="currentColor"/>
    <path
        d="M7.58209 7.27734H7.05475V5.69531C7.05475 5.40404 6.81854 5.16797 6.5274 5.16797C6.23613 5.16797 6.00006 5.40404 6.00006 5.69531V7.27734H5.47272C5.18144 7.27734 4.94537 7.51341 4.94537 7.80469V14.8359C4.94537 15.1272 5.18144 15.3633 5.47272 15.3633H7.58209C7.87323 15.3633 8.10944 15.1272 8.10944 14.8359V7.80469C8.10944 7.51341 7.87323 7.27734 7.58209 7.27734Z"
        fill="currentColor"/>
    <path
        d="M12.5273 4.07812H11.9999V2.49609C11.9999 2.20482 11.7639 1.96875 11.4726 1.96875C11.1815 1.96875 10.9453 2.20482 10.9453 2.49609V4.07812H10.4179C10.1268 4.07812 9.89056 4.31419 9.89056 4.60547V6.71484C9.89056 7.00612 10.1268 7.24219 10.4179 7.24219H10.9453V8.82422C10.9453 9.11549 11.1815 9.35156 11.4726 9.35156C11.7639 9.35156 11.9999 9.11549 11.9999 8.82422V7.24219H12.5273C12.8186 7.24219 13.0546 7.00612 13.0546 6.71484V4.60547C13.0546 4.31419 12.8186 4.07812 12.5273 4.07812Z"
        fill="currentColor"/>
    <path
        d="M2.63672 2.67188H0.527344C0.236069 2.67188 0 2.90794 0 3.19922V10.2305C0 10.5217 0.236069 10.7578 0.527344 10.7578H1.05469V14.4492C1.05469 14.7405 1.29076 14.9766 1.58203 14.9766C1.87331 14.9766 2.10938 14.7405 2.10938 14.4492V10.7578H2.63672C2.92799 10.7578 3.16406 10.5217 3.16406 10.2305V3.19922C3.16406 2.90794 2.92799 2.67188 2.63672 2.67188Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconStock"
}
</script>